import api from "../api/api";
import IContactInfo from "../interfaces/IContactInfo";
import type IProperty from "../interfaces/IProperty";

export default class ContactInfoApiService {
    public async fetchContactInfo(property: IProperty): Promise<IContactInfo> {
        const response = await api.post<IContactInfo>("/contactInfo/fetch", {
            address: property.address,
            city: property.city,
            state: property.state,
            zip: property.zip,
        });

        return response.data;
    }
}
